import { Component } from "react";

import { ErrorView } from "common/components/error";
import { Placeholder } from "common/components/placeholder";
import { ColorAnchor } from "common/components/buttons";

import { FETCH_SDR_VERSIONS } from "common/actions/common";

import { VersionWrapper } from "./versionWrapper";
import supportPageData from "./data.json";
import "./support.scss";

export class SupportPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sdr_docs: true,
            has_internal_error: false,
            loading: false,
            loaded: false,
            data: {
                version: null,
                date: null,
                all_files_url: null,
                sdr_spec_url: null,
                companion_file_url: null
            }
        };
    }
    
    componentDidMount() {
        if (this.state.sdr_docs && !this.state.loaded) {
            this.setState({
                loading: true,
                loaded: false
            });
            FETCH_SDR_VERSIONS().then((data) => {
                this.setState({
                    loaded: true,
                    loading: false,
                    data
                });
            });
        }
    }
    
    componentDidCatch(error, errorInfo) {
        this.setState({
            has_internal_error: true
        });
    }
    
    render() {
        if (this.state.has_internal_error) {
            return <ErrorView error={new Error("There was an internal error when rendering this page")} />;
        }

        const versions = Array.isArray(this.state.data) ? this.state.data : [this.state.data];

        const links = supportPageData.map((link) => (
            <div className="support-section" key={link.id}>
                <h3>{link.title}</h3>
                <div className="content">
                    <div className="description">{link.description}</div>
                    <div className="user-guide-link">
                        <a href={link.href} rel="noopener noreferrer" target="_blank">{link.hrefText}</a>
                        <span className="date-updated">{link.updated ? ` - Updated ${link.updated}` : ""}</span>
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="support-page">
                {links}
                {this.state.sdr_docs && (
                    <div className="support-section">
                        {/* eslint-disable-next-line sentence-case/sentence-case */}
                        <h3>Scheduled Delivered Reports (SDR)</h3>
                        <div>SDR allows you to automatically receive transaction level details on a scheduled basis. Files can be picked up on the Pazien SFTP or Worldpay’s SFG servers.</div>
                        <br/>
                        <div>The below SDR Request Form must be fully populated and sent to Pazien by your Worldpay representative. Reach out to your support or relationship manager with any questions.</div>
                        <ColorAnchor $color="blue-wcag-327" href="https://cdn.pazien.com/guides/Scheduled_delivered_reports_(SDR)_request_form.xlsx" target="_blank" css="padding: 0px">Scheduled_delivered_reports_(SDR)_request_form (.xlsx)</ColorAnchor>
                        <div className="content">
                            {
                                this.state.loading
                                    ? <Placeholder size="long"/>
                                    : (
                                        <>
                                            <div className="version-category"><span>Current version</span> - Merchant coding reference</div>
                                            <VersionWrapper data={versions[0]} current />

                                            {versions.length > 1
                                                ? <div className="version-category"><span>Deprecated versions</span> - A reference for merchants subscribed to SDR prior to January 2020</div>
                                                : null}
                                            {versions.slice(1).map((version) => <VersionWrapper key={version._id} data={version} />)}
                                        </>
                                    )
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
